import api from '../utils/baseUrl';

const getErrorMessage = (error: any, fallback: string) =>
    error?.response?.data?.message || error?.response?.data?.error || error?.message || fallback;

class WalletService {
    async depositFunds(body: object) {
        try {
            const response = await api.post('/api/wallet/deposit', body);
            return response.data ?? {};
        } catch (error) {
            console.error('Error while creating deposit checkout session:', error);
            throw new Error(getErrorMessage(error, 'Error creating payment intent'));
        }
    }
    async withdrawFunds(body: object) {
        try {
            const response = await api.post('/api/wallet/cashout', body);
            return response.data ?? {};
        } catch (error) {
            console.error('Error while transferring funds to user:', error);
            throw new Error(getErrorMessage(error, 'Failed to request withdrawal'));
        }
    }

    async getWallet() {
        try {
            const response = await api.get('/api/wallet');
            return response.data.wallet ?? {};
        } catch (error) {
            console.error('Error while getting wallet details:', error);
            throw new Error(getErrorMessage(error, 'Failed to load wallet details'));
        }
    }
}

export default new WalletService();
